export default function (user, na='', useEmail=false) {

  if (user) {

    const src = user.profile ? user.profile : user

    const profileName = src ? (
      (src.title ? src.title + ' ' : '') +
      (src.firstname ? src.firstname : '') +
      (src.lastname ? (src.firstname!=='' ? ' ' : '') + src.lastname : '') +
      (src.sufix ? ' ' + src.sufix.replace(/\|/g, ' ') : '')
      // + (src.suffix1 ? ' ' + src.suffix1 : '')
    ) : ''

    return profileName.trim() !== '' ?
        profileName :
      user.username && user.username.trim() !== '' ? user.username :
      ( useEmail ? (user.email && user.email.trim()!=='' ? user.email : na ) : na )

  } else {
    return na
  }
}
